import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceLoginIssuesMessage,
  LocationVarKey.VoiceSendLoginIssuesText,
  LocationVarKey.VoiceLoginIssuesTextMessage,
  LocationVarKey.VoiceForwardLoginIssues,
  LocationVarKey.VoiceLoginIssuesEscalateTo,
  LocationVarKey.VoiceLoginIssuesPhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Login Issues</PageHeader>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoiceLoginIssuesMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendLoginIssuesText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendLoginIssuesText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceLoginIssuesTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardLoginIssues} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardLoginIssues, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceLoginIssuesEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />

      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardLoginIssues, "1"), IS_EQUAL(LocationVarKey.VoiceLoginIssuesEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceLoginIssuesPhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
